"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleButton_1 = require("./RawExampleButton");
var FlatExampleButton_1 = require("./FlatExampleButton");
var LabelAndClickExampleButton_1 = require("./LabelAndClickExampleButton");
var StylingExampleButton_1 = require("./StylingExampleButton");
var PropertiesButton_1 = require("./PropertiesButton");
exports.ComponentButtonPage = function () { return (React.createElement(common_1.Page, { headerText: "Button" },
    React.createElement(common_1.Paragraph, null, "Button is a nice and beatiful component that's looks like a button or a link."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleButton_1.RawExampleButton, null),
    React.createElement(FlatExampleButton_1.FlatExampleButton, null),
    React.createElement(LabelAndClickExampleButton_1.LabelAndClickExampleButton, null),
    React.createElement(StylingExampleButton_1.StylingExampleButton, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesButton_1.PropertiesButton, null))); };
exports.ComponentButtonPage.displayName = 'ComponentButtonPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/ComponentButtonPage.tsx
// module id = 633
// module chunks = 0